import { render, staticRenderFns } from "./LockedCategoryIcon.vue?vue&type=template&id=c5fe0b6c&"
import script from "./LockedCategoryIcon.vue?vue&type=script&lang=js&"
export * from "./LockedCategoryIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports